import React from 'react';
import ProductCard from './ProductCard';
import Pagination from './Pagination';
import LayerNavigation from './LayerNavigation';

const ProductList = ({
  products = [],
  totalCount = 0,
  pageInfo = {},
  currentPage = 1,
  onPageChange,
  currentSort,
  onSortChange,
  // Layer navigation props
  enabledLayerNavigation = false,
  activeFilters = [],
  onAddFilter,
  onRemoveFilter,
  onClearAllFilters,
  hasActiveFilters = false,
  isLayerNavigationVisible = true,
  onHideLayerNavigation,
  onShowLayerNavigation,
  onSetPriceRange,
  categoryId,
  searchTerm = null
}) => {
  return (
    <div className="category-content">
      {enabledLayerNavigation && (
        <div className="sidebar">
          <LayerNavigation
            filters={activeFilters}
            onAddFilter={onAddFilter}
            onRemoveFilter={onRemoveFilter}
            onClearAllFilters={onClearAllFilters}
            hasActiveFilters={hasActiveFilters}
            isVisible={isLayerNavigationVisible}
            onHide={onHideLayerNavigation}
            onShow={onShowLayerNavigation}
            onSetPriceRange={onSetPriceRange}
            enabledLayerNavigation={enabledLayerNavigation}
            categoryId={categoryId}
            searchTerm={searchTerm}
          />
        </div>
      )}

      <div className={`main-content ${enabledLayerNavigation ? 'with-sidebar' : 'full-width'}`}>
        <div className="category-toolbar">
          <div style={{ display: 'flex', alignItems: 'center', gap: '1.5rem', flexWrap: 'wrap', flex: 1 }}>
            <p className="total-count">
              Total products: {totalCount}
            </p>

            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <label htmlFor="sort-select" style={{ fontSize: '0.875rem', fontWeight: '500', color: '#666' }}>
                Sort by:
              </label>
              <select
                id="sort-select"
                value={currentSort || 'name_asc'}
                onChange={(e) => onSortChange(e.target.value || null)}
                style={{
                  padding: '0.5rem 2rem 0.5rem 0.75rem',
                  border: '1px solid #d1d5db',
                  borderRadius: '6px',
                  fontSize: '0.875rem',
                  backgroundColor: 'white',
                  cursor: 'pointer',
                  outline: 'none'
                }}
              >
                <option value="name_asc">Name: A-Z</option>
                <option value="name_desc">Name: Z-A</option>
                <option value="price_asc">Price: Low to High</option>
                <option value="price_desc">Price: High to Low</option>
              </select>
            </div>

            {currentPage > 1 && (
              <p className="page-info" style={{ marginLeft: 'auto' }}>
                Page {pageInfo?.current_page} of {pageInfo?.total_pages}
              </p>
            )}
          </div>
        </div>

        <div className="product-grid">
          {products.map((product) => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>

        {totalCount === 0 && (
          <div className="no-products">
            {hasActiveFilters
              ? 'No products match your current filters. Try adjusting your selection.'
              : 'No products found.'
            }
          </div>
        )}

        <Pagination
          currentPage={currentPage}
          totalPages={pageInfo?.total_pages || 1}
          onPageChange={onPageChange}
        />
      </div>
    </div>
  );
};

export default ProductList;
